// src/routes/ProtectedRoute.jsx
import { Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { validateToken } from '../services/apiService';
import useAutoLogout from '../pages/Login/autoLogout';

const ProtectedRoute = () => {
  const [isValid, setIsValid] = useState(null);
  const token = localStorage.getItem('token');
  useAutoLogout();

  useEffect(() => {
    const checkToken = async () => {
      if (!token) {
        setIsValid(false);
        return;
      }

      const valid = await validateToken();
      setIsValid(valid);
    };

    checkToken();
    // Validate once when this route mounts (now stable for the whole
    // authenticated session, not remounted per navigation) rather than on
    // every render, which previously re-hit the API on each route change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isValid === null) {
    return <div>Loading...</div>; // simple loading fallback
  }

  if (!token || !isValid) {
    localStorage.removeItem('token');
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
